<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
  >
    <div class="content">
      <div class="header">
        <template>
          <h1 class="title">{{ $t('new_work_instruction_package') }}</h1>
        </template>
      </div>

      <div class="columns" v-for="item in items" :key="item.key">
        <div class="column">
          <b-field>
            <b-checkbox v-model="item.checked" @input="onCheckboxChange(item)">
              {{ item.label }}
            </b-checkbox>
          </b-field>
        </div>
        <div class="column is-three-quarters">
          <b-field>
            <b-input v-model="item.title" :disabled="!item.checked"></b-input>
          </b-field>
        </div>
      </div>

      <footer class="footer-buttons">
        <b-button label="Cancel" @click="onClose" type="is-danger" />
        <b-button label="Save" @click="onSave" type="is-success" />
      </footer>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'CreateWIPackageModal',

  props: {
    job: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      items: [],
    };
  },

  computed: {
    sitePhases() {
      const site = this.$store.state.sites.find(
        (s) => s._id === this.job?.executingSite
      );
      return site?.jobPhases || [];
    },
  },

  async created() {
    if (!this.$store.state.sites?.length) {
      await this.$store.dispatch('getSites');
    }
    this.items = this.buildItems();
  },

  methods: {
    buildItems() {
      const customItem = {
        key: 'custom',
        label: 'Custom',
        checked: false,
        title: '',
      };

      const phaseItems = this.sitePhases.map((phase) => ({
        key: phase._id,
        label: phase.name,
        checked: false,
        title: '',
      }));

      return [...phaseItems, customItem];
    },
    onCheckboxChange(item) {
      // The Custom option keeps an empty, user-provided name.
      if (item.key === 'custom') {
        return;
      }
      if (item.checked && !item.title) {
        const isEditor = this.$route.name.includes('editor');
        if (isEditor) {
          item.title = item.label;
        } else {
          const jobNumber =
            this.job?.projectInfoText ||
            this.job?.workOrderNumber ||
            this.job?.documentNumber ||
            '';
          item.title = jobNumber ? `${item.label} - ${jobNumber} ` : item.label;
        }
      }
    },
    onClose() {
      this.$emit('close');
    },
    onSave() {
      const checkedItems = this.items.filter((item) => item.checked);
      const hasEmptyTitle = checkedItems.some((item) => !item.title.trim());
      if (hasEmptyTitle) {
        this.$buefy.toast.open({
          duration: 5000,
          message: 'Please enter a name for each selected option.',
          type: 'is-danger',
        });
        return;
      }
      const packages = checkedItems.map((item) => ({
        title: item.title,
        sortOrder: this.items.indexOf(item),
      }));
      this.$emit('save', packages);
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.columns {
  align-items: center;
}
</style>
